import React from "react";
import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
  Stack,
  CardMedia,
  Paper,
} from "@mui/material";
import Img3 from "./cardImg/Card33.png";
// import Img2 from "./cardImg/SmartBroadcasting22.png";
import Img2 from "./img/Analytics.png";
import img6 from "./img/analytics54.png";
import { useNavigate } from "react-router-dom";
const Card7 = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  const isMd = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLg = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isXl = useMediaQuery(theme.breakpoints.up("lg"));
  const handleClick1 = () => {
    // navigate("/solution1");
    navigate("/products", { state: { index: 6 } });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xl: "row", lg: "row", md: "row", sm: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        // backgroundColor: "#4f2449",
        // backgroundColor: "#c2a3bd",
        backgroundColor: "#eee2c8",
        // backgroundImage: `url(${Img3})`, // Set the main background image
        // backgroundSize: "cover", // Ensure the main image covers the entire Box
        // backgroundPosition: "center", // Center the main image
        // backgroundRepeat: "no-repeat", // Prevent tiling of the main image
        color: "#FFFFFF",
        borderRadius: "8px",
        overflow: "hidden",
        padding: isMd || isSm || isXs ? "16px" : "16px",
        width: "100%",
        // border: "1px solid red",
        position: "relative", // Enable positioning for the bottom-right image
        height: { xl: "300px", lg: "300px", md: "280px", xs: "200px" }, // Adjust the height of the card as needed
        marginTop: { xl: "0px", lg: "0px", md: "0px", sm: "0px", xs: "0px" },
      }}
    >
      {/* Text Section */}
      <Box
        sx={{
          // height: {
          //   xl: "232px",
          //   lg: "232px",
          //   md: "232px",
          //   sm: "232px",
          //   xs: "160px",
          // },
          height: "100%",
          width: { xl: "60%", lg: "50%", md: "100%", sm: "100%", xs: "100%" },
        }}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            // border: "2px solid green",
            // alignItems: "center",
            justifyContent: "flex-start",
            marginRight: {
              xl: "8px",
              lg: "0px",
              md: "0px",
              sm: "0px",
              xs: "0px",
            },
          }}
        >
          <Stack
            sx={{
              height: "80px",
              width: "80px",
              // border: "1px solid red",
            }}
          >
            <img
              src={Img2}
              alt="Forex Management"
              style={{
                width: "90%", // Image takes full width
                height: "90%",
                // padding: "4px",
                padding: isXs
                  ? "0px"
                  : isSm
                    ? "0px"
                    : isMd
                      ? "8px"
                      : isLg
                        ? "8px"
                        : "8px",
                objectFit: "contain",
              }}
            />
          </Stack>

          <Stack
            sx={{
              fontSize: {
                lg: "27px",
                xl: "27px",
                md: "27px",
                xs: "18px",
                sm: "28px",
              },
              lineHeight: {
                lg: "30px",
                xl: "30px",
                md: "30px",
                xs: "23px",
                sm: "36px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: "600",
              color: "rgba(12, 12, 12, 0.8)",
              fontFamily: "'Roboto', sans-serif",
              textAlign: "left",
            }}
          >
            {" "}
            Real-time analytics dashboard
          </Stack>
        </Stack>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            lineHeight: {
              lg: "21px",
              xl: "21px",
              md: "21px",
              xs: "20px",
              sm: "20px",
            },
            // fontSize: "18px",
            fontSize: {
              lg: "17px",
              xl: "17px",
              md: "17px",
              xs: "16px",
              sm: "20px",
            },
            fontFamily: "'Roboto', sans-serif",
            fontWeight: {
              lg: "400",
              xl: "400",
              xs: "400",
              sm: "400",
            },
            color: "text.secondary",
            marginTop: {
              xl: "8px",
              lg: "8px",
              md: "8px",
              sm: "8px",
              xs: "0px",
            },
            marginRight: {
              xl: "8px",
              lg: "4px",
              md: "0px",
              sm: "0px",
              xs: "0px",
            },
          }}
        >
          <Stack>
            Track response rates and campaign performance with live analytics and optimize your strategy instantly using actionable insights.
          </Stack>
        </Stack>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            marginTop: {
              xl: "0px",
              lg: "0px",
              md: "8px",
              sm: "8px",
              xs: "0px",
            },
          }}
        >
          <Stack>
            <Button
              variant="outlined"
              sx={{
                color: "rgb(5, 78, 146)",
                border: "1px solid rgb(5, 78, 146)",

                "&:hover": {
                  color: "rgb(31, 133, 192)", // Hover background
                  borderColor: "rgb(31, 133, 192)", // Hover border
                },
                textTransform: "none",
                fontSize: isMd || isSm || isXs ? "12px" : "16px",
                width: "fit-content",
                borderRadius: "8px",
                marginTop: {
                  xl: "12px",
                  lg: "12px",
                  md: "0px",
                  sm: "0px",
                  xs: "12px",
                },
                // marginLeft: {
                //   xl: "100px",
                //   lg: "96px",
                //   md: "66px",
                //   sm: "0px",
                //   xs: "64px",
                // },
                display: "none",
              }}
              size="small"
              onClick={handleClick1}
            >
              Know More
            </Button>
          </Stack>
        </Stack>
      </Box>

      <Box
        sx={{
          height: "100%",
          width: "40%",
          // border: "1px solid green",
          display: {
            xl: "flex",
            lg: "flex",
            md: "none",
            sm: "none",
            xs: "none",
          },
        }}
      >
        <CardMedia
          component="img"
          image={img6}
          alt="card5Img"
          sx={{ height: "100%", width: "100%", objectFit: "contain" }}
        />
      </Box>
    </Box>
  );
};

export default Card7;
